import getCountyFromAddressMain from '@/helpers/getCountyFromAddress';

const getCountyFromAddress = async (usAddress: unknown): Promise<string | null> => {
  if (!(
    usAddress
    && typeof usAddress === 'object'
    && 'city' in usAddress && usAddress.city && typeof usAddress.city === 'string'
    && 'state' in usAddress && usAddress.state && typeof usAddress.state === 'string'
    && 'zip' in usAddress && usAddress.zip && typeof usAddress.zip === 'string'
    && 'line1' in usAddress && usAddress.line1 && typeof usAddress.line1 === 'string'
  )) {
    return null;
  }

  const county = await getCountyFromAddressMain({
    address: usAddress.line1,
    city: usAddress.city,
    state: usAddress.state,
    zipcode: usAddress.zip,
  });

  return county ?? null;
};

export default getCountyFromAddress;